import { ProductParameterValue } from './parameter';

export type ProductConfiguration = { [key: string]: ProductParameterValue[]; };

export type ProductConfigurationMap = { [key: string]: string[]; };

export const productConfigurationContainsValue = (config: ProductConfiguration, key: string, valueKey: string) =>
    config && key in config && Array.isArray(config[key]) && config[key].some(value => value.key == valueKey);

export const productConfigurationTypePriceMultiplier = (config: ProductConfiguration) =>
    'types' in config && config['types'] && config['types'].length
        ? config['types'][0].priceMultiplier
        : 1;